import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Star from './Star';
import { colors } from '../../../constants/colors';

const STARS = Array.apply(null, { length: 5 });
const Root = styled.div`
  white-space: nowrap;
`;

export default class StarRating extends PureComponent {
  static propTypes = {
    /* Identifier needs to be a string which will be unique on the page, or at least unique enough
     * that there isn't any conflicts with other mounting and un-mounting StarRating components.
     * Otherwise, the stars will randomly disappear. If you've come to this file in search of
     * missing stars, this is probably your issue. */
    identifier: PropTypes.string.isRequired,
    rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    spacing: PropTypes.string,
  };

  static defaultProps = {
    primaryColor: colors.peaches,
    secondaryColor: colors.borderLine,
    spacing: '2px',
  };

  getFillPercentage = pos => Math.round(Math.max(Math.min(this.rating - pos, 1), 0) * 100);

  rating = parseFloat(this.props.rating) || 0;

  render = () => {
    const { className, size, identifier, primaryColor, secondaryColor, spacing } = this.props;
    const id = identifier.replace(/'|\s/g, '');
    return (
      <Root className={className}>
        {STARS.map((_, pos) => (
          <Star
            key={pos}
            size={size}
            identifier={id}
            percentFilled={this.getFillPercentage(pos)}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            spacing={spacing}
          />
        ))}
      </Root>
    );
  };
}
